import PropTypes from "prop-types";
import useTranslation from "next-translate/useTranslation";

import { Grid, Link, Typography, Image } from "@/components/core";

export function StoreBadge({ icon, children, link }: any) {
  return (
    <Link href={link}>
      <Grid
        sx={{ border: "1px solid #c3c3c3", borderRadius: 2, padding: 0.5 }}
        spacing={1}
        wrap="nowrap"
      >
        <Grid.Item>{icon}</Grid.Item>
        <Grid.Item>
          <Typography fontSize={13} color="white">
            {children}
          </Typography>
        </Grid.Item>
      </Grid>
    </Link>
  );
}

export function AppStoreBadge() {
  const { t } = useTranslation("common");

  const icon = <Image width={25} height={25} src="/svg/store/apple-logo.svg" />;

  return (
    <StoreBadge link="https://www.google.com" icon={icon}>
      {t("appStoreBadge")}
    </StoreBadge>
  );
}

export function GooglePlayStoreBadge() {
  const { t } = useTranslation("common");

  const icon = <Image width={25} height={25} src="/svg/store/google-play-logo.svg" />;

  return (
    <StoreBadge link="https://www.google.com" icon={icon}>
      {t("googlePlayBadge")}
    </StoreBadge>
  );
}

export function AppGalleryStoreBadge() {
  const { t } = useTranslation("common");

  const icon = <Image width={25} height={25} src="/svg/store/appgallery-logo.svg" />;

  return (
    <StoreBadge link="https://www.google.com" icon={icon}>
      {t("appGalleryBadge")}
    </StoreBadge>
  );
}

StoreBadge.propTypes = {
  icon: PropTypes.any,
  children: PropTypes.any,
  link: PropTypes.string,
};
